export default __webpack_public_path__ + "static/media/google_play_store.f7388ef4.png";